export default __webpack_public_path__ + "static/media/Under Maintenance.c86740cb.gif";